import storage from './storage';

export const TOKEN_NAME = '@wavelight/token';

export const getAuthToken = () => storage.get(TOKEN_NAME);
export const setAuthToken = (token: string) => storage.set(TOKEN_NAME, token);
export const clearAuthToken = () => storage.remove(TOKEN_NAME);

export const getTokenRemainingTimeInSeconds = () => {
  const token = getAuthToken();
  if (token === '' || token === undefined || token === null) {
    return 0;
  }
  const payloadBase64 = token.split('.')[1];
  const decodedPayload = JSON.parse(window.atob(payloadBase64));
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const expirationTimeInSeconds = decodedPayload.exp;
  const remainingTimeInSeconds = expirationTimeInSeconds - currentTimeInSeconds;

  return remainingTimeInSeconds;
};
